import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css'; // <--- เพิ่มบรรทัดนี้เข้ามา
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// ป้องกันการกดยืนยันค้างบนมือถือแล้วขึ้นเมนูระบบ (Context Menu)
window.addEventListener('contextmenu', (e) => {
  if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA') {
    e.preventDefault();
  }
}, { passive: false });
